const { getElement } = window.BAO.Utils

class VariantOptions extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.drawer = this.closest('.drw-Drawer')

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'inert'
        ) {
          if (this.drawer.hasAttribute('inert')) {
            this.onDrawerClosed()
          }
        }
      })
    })

    observer.observe(this.drawer, { attributes: true })
  }

  onDrawerClosed (e) {
    if (this.hasAttribute('aria-expanded', 'false')) {
      this.setAttribute('aria-expanded', 'true')
      getElement(
        `[key="drawer-options-${this.dataset.form}"] [data-product-form-external-el="success"]`,
      ).setAttribute('aria-expanded', 'false')
    }
  }
}

if (!customElements.get('variant-options')) {
  customElements.define('variant-options', VariantOptions)
}
